/**
 * @prettier
 */

import React from 'react';
import _sortBy from 'lodash/sortBy';
import { ptToPx } from '../../../../util';
import { useMobileCheck } from '../util/hooks';
import MultiSample from '../MultiSample/MultiSample';
import ImageElement from './ImageElement';
import TextElement from './TextElement';
import styles from './styles.module.less';

const Canvas = ({
  isMulti,
  page,
  isRounded,
  customizations = {},
  updateForm,
  width,
  activePreview,
  multiPreviewState,
  setMultiPreviewState,
  enableHoverActions,
}) => {
  const isMobile = useMobileCheck();

  if (!page) return null;

  const { width: widthPt, height: heightPt } = page;

  const templateWidth = ptToPx(widthPt);
  const templateHeight = ptToPx(heightPt);
  const elements = page.elements || [];

  const orderedElements = _sortBy(elements, e => e.layer);

  let { photo, pixelCrop, uploadcareFile } = customizations;
  const { photoSet, pixelCropSet, uploadcareFileSet } = customizations;

  if (isMulti) {
    photo = photoSet[activePreview];
    pixelCrop = pixelCropSet[activePreview];
    uploadcareFile = uploadcareFileSet[activePreview];
  }

  const hasCustomImage = !!uploadcareFile || !!(photo && pixelCrop);
  const customImageIndex = orderedElements.findIndex(
    element => element.content_type === 'IMAGE' && element.customizable
  );

  const renderElement = (element, i) => {
    switch (element.content_type) {
      case 'IMAGE': {
        if (hasCustomImage && customImageIndex === i) {
          return (
            <ImageElement
              key={i}
              isMulti={isMulti}
              element={element}
              pixelCrop={pixelCrop}
              photo={photo}
              uploadcareFile={uploadcareFile}
              isRounded={isRounded}
            />
          );
        }
        return <ImageElement key={i} element={element} isRounded={isRounded} />;
      }
      case 'TEXT': {
        return <TextElement key={i} element={element} />;
      }
      default: {
        return null;
      }
    }
  };

  const scale = width / Math.max(templateWidth, templateHeight);

  return (
    <div className={styles.canvasBox} style={{ height: templateHeight * scale, width }}>
      <div
        className={styles.canvas}
        style={{
          width: templateWidth,
          height: templateHeight,
          marginLeft: (width - templateWidth * scale) / 2,
          transform: `scale(${scale})`,
        }}
      >
        {orderedElements.map(renderElement)}
        {isMulti && enableHoverActions && (
          <div className={styles.canvasOverlay}>
            <div className={styles.photoActions}>
              <MultiSample.UploadButton
                templatePage={page}
                customizations={customizations}
                updateForm={updateForm}
                multiPreviewState={multiPreviewState}
                setMultiPreviewState={setMultiPreviewState}
                isMobile={isMobile}
                style={{ transform: `scale(${1 / scale})`, maxWidth: 0.75 * width }}
              />
              {photo && (
                <MultiSample.CropButton
                  templatePage={page}
                  updateForm={updateForm}
                  multiPreviewState={multiPreviewState}
                  setMultiPreviewState={setMultiPreviewState}
                  isMobile={isMobile}
                  style={{ transform: `scale(${1 / scale})`, maxWidth: 0.8 * width }}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Canvas.defaultProps = {
  width: 280,
};

export default Canvas;
